"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bytesToOutputValue = exports.bufferToHex = void 0;
exports.floatToBytes = floatToBytes;
exports.hexToBuffer = void 0;
exports.intToBytes = intToBytes;
exports.signedIntToBytes = signedIntToBytes;
exports.unpackToInt = exports.unpackToHex = exports.unpackToFloat = exports.unpackLen = void 0;
var _buffer = _interopRequireDefault(require("buffer"));
var _long = _interopRequireDefault(require("long"));
var _errors = require("../errors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const isHexa = value => {
  // test if value is string?
  return /^[0-9a-fA-F]*$/.test(value);
};

/**
 * Transform int to bytes
 *
 * @param {number} value Integer to be transformed to bytes
 * @param {number} bytes How many bytes this number uses
 *
 * @return {Buffer} number in bytes
 * @inner
 */
function intToBytes(value, bytes) {
  const arr = new ArrayBuffer(bytes);
  const view = new DataView(arr);
  if (bytes === 1) {
    // byteOffset = 0;
    view.setUint8(0, value);
  } else if (bytes === 2) {
    // byteOffset = 0; isLittleEndian = false
    view.setUint16(0, value, false);
  } else if (bytes === 4) {
    // byteOffset = 0; isLittleEndian = false
    view.setUint32(0, value, false);
  }
  return _buffer.default.Buffer.from(arr);
}

/**
 * Transform signed int to bytes (1, 2, or 4 bytes)
 *
 * @param {number} value Integer to be transformed to bytes
 * @param {number} bytes How many bytes this number uses
 *
 * @return {Buffer} number in bytes
 * @inner
 */
function signedIntToBytes(value, bytes) {
  let arr = new ArrayBuffer(bytes);
  const view = new DataView(arr);
  if (bytes === 1) {
    // byteOffset = 0
    view.setInt8(0, value);
  } else if (bytes === 2) {
    // byteOffset = 0; isLittleEndian = false
    view.setInt16(0, value, false);
  } else if (bytes === 4) {
    view.setInt32(0, value, false);
  } else if (bytes === 8) {
    // In case of 8 bytes I need to handle the int with a Long lib
    const long = _long.default.fromNumber(value, false);
    arr = new Uint8Array(long.toBytesBE()).buffer;
  }
  return _buffer.default.Buffer.from(arr);
}

/**
 * Transform float to bytes
 *
 * @param {number} value Integer to be transformed to bytes
 * @param {number} bytes How many bytes this number uses
 *
 * @return {Buffer} number in bytes
 * @inner
 */
function floatToBytes(value, bytes) {
  const arr = new ArrayBuffer(bytes);
  const view = new DataView(arr);
  if (bytes === 8) {
    // byteOffset = 0; isLitteEndian = false
    view.setFloat64(0, value, false);
  }
  return _buffer.default.Buffer.from(arr);
}
const hexToBuffer = value => {
  if (!isHexa(value)) {
    throw new Error('hexToBuffer: argument must be a strict hex string.');
  }
  return Buffer.from(value, 'hex');
};

/**
 * Validates if buffer has enough bytes to unpack
 *
 * @param {number} n The size to unpack
 * @param {Buffer} buff The buffer to unpack
 *
 * @throws ParseError when requests to unpack more bytes than the buffer size
 */
exports.hexToBuffer = hexToBuffer;
const validateLenToUnpack = (n, buff) => {
  if (buff.length < n) {
    throw new _errors.ParseError(`Don't have enough bytes to unpack. Requested ${n} and buffer has ${buff.length}`);
  }
};

/**
 * Unpacks a buffer size
 *
 * @param {number} n The size of the buffer to unpack
 * @param {Buffer} buff The buffer to unpack
 *
 * @return {[Buffer, Buffer]} The unpacked buffer followed by the rest of the buffer
 */
const unpackLen = (n, buff) => {
  validateLenToUnpack(n, buff);
  return [buff.slice(0, n), buff.slice(n)];
};

/**
 * Unpacks an integer from a buffer
 *
 * @param {number} n The size of the number in bytes
 * @param {boolean} signed If the number is signed
 * @param {Buffer} buff The buffer to unpack
 *
 * @return {[number, Buffer]} The unpacked number followed by the rest of the buffer
 */
exports.unpackLen = unpackLen;
const unpackToInt = (n, signed, buff) => {
  validateLenToUnpack(n, buff);
  let retInt;
  const slicedBuff = buff.slice(0, n);
  if (n === 1) {
    if (signed) {
      retInt = slicedBuff.readInt8(0);
    } else {
      retInt = slicedBuff.readUInt8(0);
    }
  } else if (n === 2) {
    if (signed) {
      retInt = slicedBuff.readInt16BE(0);
    } else {
      retInt = slicedBuff.readUInt16BE(0);
    }
  } else if (n === 4) {
    if (signed) {
      retInt = slicedBuff.readInt32BE(0);
    } else {
      retInt = slicedBuff.readUInt32BE(0);
    }
  } else if (n === 8) {
    // We have only signed ints here
    // readBigInt64BE exists only in node versions > 8
    // the else block is used for versions <= 8 and usage in web browsers
    if (slicedBuff.readBigInt64BE) {
      retInt = Number(slicedBuff.readBigInt64BE());
    } else {
      retInt = slicedBuff.readIntBE(0, 8);
    }
  } else {
    throw new _errors.ParseError('Invalid value for n.');
  }
  return [retInt, buff.slice(n)];
};

/**
 * Unpacks a float from a buffer
 *
 * @param {Buffer} buff The buffer to unpack
 *
 * @return {[number, Buffer]} The unpacked float followed by the rest of the buffer
 */
exports.unpackToInt = unpackToInt;
const unpackToFloat = buff => {
  const n = 8;
  validateLenToUnpack(n, buff);
  const retFloat = buff.slice(0, n).readDoubleBE(0);
  return [retFloat, buff.slice(n)];
};

/**
 * Unpacks a hex from a buffer
 *
 * @param {number} n The size of the hex to unpack
 * @param {Buffer} buff The buffer to unpack
 *
 * @return {[string, Buffer]} The unpacked hex followed by the rest of the buffer
 */
exports.unpackToFloat = unpackToFloat;
const unpackToHex = (n, buff) => {
  const unpackedRet = unpackLen(n, buff);
  const unpackedHex = bufferToHex(unpackedRet[0]);
  return [unpackedHex, unpackedRet[1]];
};

/**
 * Transforms buffer to hex
 *
 * @param {Buffer} buff The buffer to be transformed to hex
 *
 * @return {string} Hexadecimal of the buffer
 */
exports.unpackToHex = unpackToHex;
const bufferToHex = buff => {
  return buff.toString('hex');
};

/**
 * Transforms buffer to output value
 * First we get the highByte value to check if it was a 8-byte or 4-byte value
 * Then we unpack the integer and multiply by the sign.
 *
 * @param srcBuf The buffer to unpack the value
 *
 * @return Output value and rest of buffer after unpacking
 */
exports.bufferToHex = bufferToHex;
const bytesToOutputValue = srcBuf => {
  // Copies buffer locally, not to change the original parameter
  let buff = Buffer.from(srcBuf);
  const [highByte] = unpackToInt(1, true, buff);
  let sign;
  let value;
  if (highByte < 0) {
    // 8 bytes
    sign = -1;
    [value, buff] = unpackToInt(8, true, buff);
  } else {
    // 4 bytes
    sign = 1;
    [value, buff] = unpackToInt(4, true, buff);
  }
  return [value * sign, buff];
};
exports.bytesToOutputValue = bytesToOutputValue;